import { FC } from 'react'

import { FF, FormType, RadioGroup, Select, TextareaInput } from 'ui/components'
import { Col, Col2x, FormRow } from 'ui/themes/globalStyles'

import { QuestionnaireDemo } from '../../../../../../types'
import * as SC from '../../../../style'

export const Review: FC<{ formApi: FormType<QuestionnaireDemo> }> = ({ formApi }) => {
  return (
    <>
      <FormRow>
        <Col>
          <SC.SecondText>
            Review the account file to ensure internet searches were completed on the business name, its owner(s),
            manager(s), and signer(s)
          </SC.SecondText>
        </Col>
        <Col>
          <formApi.Field
            name="businessNameInternetSearchReview"
            children={(field) => <FF field={field} input={(p) => <RadioGroup yesNo valueType="boolean" {...p} />} />}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <SC.SecondText>Complete the HRR-SAR Log showing timeline of completion</SC.SecondText>
        </Col>
        <Col>
          <formApi.Field
            name="sarLogComplete"
            children={(field) => <FF field={field} input={(p) => <RadioGroup yesNo valueType="boolean" {...p} />} />}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col2x>
          <formApi.Field
            name="summaryReviewReasonable"
            children={(field) => (
              <FF
                field={field}
                label="Summary: Was the activity reviewed reasonable for the customer?"
                input={(p) => <TextareaInput maxLength={5000} {...p} />}
              />
            )}
          />
        </Col2x>
      </FormRow>
      <FormRow>
        <Col2x>
          <formApi.Field
            name="reviewSummary"
            children={(field) => (
              <FF field={field} label="Review Summary" input={(p) => <TextareaInput maxLength={5000} {...p} />} />
            )}
          />
        </Col2x>
      </FormRow>
      <FormRow>
        <Col2x>
          <formApi.Field
            name="notableChanges"
            children={(field) => (
              <FF
                field={field}
                label="Notable Changes Since Last Review"
                input={(p) => <TextareaInput maxLength={5000} {...p} />}
              />
            )}
          />
        </Col2x>
      </FormRow>
      <FormRow>
        <Col2x>
          <formApi.Field
            name="followUp"
            children={(field) => (
              <FF
                field={field}
                label="Follow Up (if required)"
                input={(p) => <TextareaInput maxLength={5000} {...p} />}
              />
            )}
          />
        </Col2x>
      </FormRow>
      <FormRow>
        <Col>
          <formApi.Field
            name="previousSARFilingStatus"
            children={(field) => (
              <FF
                field={field}
                label="Previous SAR Filing Status"
                input={(p) => (
                  <Select
                    data={[
                      {
                        label: 'Limited SAR',
                        value: 'limited_sar'
                      },
                      {
                        label: 'Priority SAR',
                        value: 'priority_sar'
                      }
                    ]}
                    {...p}
                  />
                )}
              />
            )}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <formApi.Field
            name="currentSARFilingStatus"
            children={(field) => (
              <FF
                field={field}
                label="Current SAR Filing Status"
                input={(p) => (
                  <Select
                    data={[
                      {
                        label: 'Limited SAR',
                        value: 'limited_sar'
                      },
                      {
                        label: 'Priority SAR',
                        value: 'priority_sar'
                      },
                      {
                        label: 'Termination',
                        value: 'termination_sar'
                      }
                    ]}
                    {...p}
                  />
                )}
              />
            )}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <SC.SecondText>Did the SAR filing status change from the previous review?</SC.SecondText>
        </Col>
        <Col>
          <formApi.Field
            name="sarFilingStatusChanged"
            children={(field) => <FF field={field} input={(p) => <RadioGroup yesNo valueType="boolean" {...p} />} />}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col2x>
          <formApi.Field
            name="sarFilingStatusChangedExplanation"
            children={(field) => (
              <FF
                field={field}
                label="If Yes, please provide explanation:"
                input={(p) => <TextareaInput maxLength={5000} {...p} />}
              />
            )}
          />
        </Col2x>
      </FormRow>
    </>
  )
}
